import { FormattedMessage } from '@99designs/common/i18n';
import * as React from 'react';
import { FormattedRelative } from 'react-intl';

export interface Props {
    lastSeenAt: string;
    isOnline: boolean;
}

class OnlineStatus extends React.Component<Props> {
    render() {
        return (
            <>
                {this.props.isOnline ? (
                    __('Online now')
                ) : (
                    <FormattedMessage
                        message={__('Online {time}')}
                        values={{ time: <FormattedRelative value={this.props.lastSeenAt} /> }}
                    />
                )}
            </>
        );
    }
}

export default OnlineStatus;
